<template>
  <v-dialog
    v-model="dialog"
    scrollable
    width="400"
    persistent
  >
    <v-card
      class=""
      flat
      tile
    >
      <v-toolbar
        color="light-blue darken-3"
        flat
        dense
      >
        <v-toolbar-title class="white--text">
          {{ $t('m.signup') }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          color=""
          @click="handleCancel"
          dark
          :disabled="loading"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        />
      </v-toolbar> <!-- end toolbar -->

      <v-container fluid>
        <v-card
          class="px-6"
          flat
          tile
        >
          <div class="text-center py-4">
            <img
              src="../assets/portdistancelogo.png"
              style="width:260px;"
              alt=""
            >
          </div>

          <v-form
            fluid
            ref="form"
          >
            <v-text-field
              v-model="email"
              :label="$t('m.email')"
              prepend-icon="mdi-email-outline"
              :error-messages="emailErrors"
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            />

            <v-text-field
              v-model="password"
              :label="$t('m.password')"
              :error-messages="passwordErrors"
              prepend-icon="mdi-lock-outline"
              :append-icon="passwordShow ? 'mdi-eye' : 'mdi-eye-off'"
              :type="passwordShow ? 'text' : 'password'"
              @click:append="passwordShow = !passwordShow"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
            />

            <v-text-field
              v-model="nickname"
              :error-messages="nicknameErrors"
              :label="$t('m.nickname')"
              :hint="$t('m.nicknameHint')"
              prepend-icon="mdi-account-outline"
              @input="$v.nickname.$touch()"
              @blur="$v.nickname.$touch()"
            />

            <v-text-field
              v-model="company"
              :error-messages="companyErrors"
              :label="$t('m.company')"
              :hint="$t('m.companyHint')"
              prepend-icon="mdi-badge-account-horizontal-outline"
              @input="$v.company.$touch()"
              @blur="$v.company.$touch()"
            />

            <v-btn
              block
              class="mt-4"
              :disabled="loading"
              depressed
              color="success"
              @click="onSubmit"
            >
              {{ $t('m.signup') }}
            </v-btn>
          </v-form>
          <v-card
            class="text-center mt-3"
            flat
            tile
          >
            <v-btn
              text
              color="primary"
              @click="handleCancel"
              :disabled="loading"
            >
              {{ $t('m.hasAccount') }}
            </v-btn>
          </v-card>
        </v-card>
      </v-container> <!-- end workspace -->
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'
import httpClient from '@/api/httpClient'
import Utils from '@/utils/index'
import Constant from '@/constant/index'

export default {
  mixins: [validationMixin],
  name: 'SignUpDialog',
  props: [
    'visible'
  ],
  data () {
    return {
      dialog: false,

      valid: true,
      passwordShow: false,
      password: '',
      email: '',
      nickname: '',
      company: '',
      loading: false
    }
  },

  validations: {
    email: {
      required,
      email,
      async isUnique (value) {
        if (value === '' || value.indexOf('@') === -1) return true
        const response = await httpClient.get('/auth/OPUserEmailCheck?Email=' + value)
        return Boolean(response.data === 0)
      }
    },
    password: { required, minLength: minLength(6) },
    nickname: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(16),
      async isUnique (value) {
        if (value.length < 4 || value.length > 16) return true
        const response = await httpClient.get('/auth/OPUserOperNameCheck?OperName=' + value)
        return Boolean(response.data === 0)
      }
    },
    company: { required, minLength: minLength(6), maxLength: maxLength(30) }
  },

  created () {
  },

  computed: {
    emailErrors () {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.required && errors.push(this.$t('m.required'))
      !this.$v.email.email && errors.push(this.$t('m.emailInvalid'))
      !this.$v.email.isUnique && errors.push(this.$t('m.emailBeUsed'))
      return errors
    },

    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push(this.$t('m.required'))
      !this.$v.password.minLength && errors.push(this.$t('m.passwordMinLength'))
      return errors
    },

    nicknameErrors () {
      const errors = []
      if (!this.$v.nickname.$dirty) return errors
      !this.$v.nickname.required && errors.push(this.$t('m.required'))
      !this.$v.nickname.minLength && errors.push(this.$t('m.nicknameInvalid'))
      !this.$v.nickname.maxLength && errors.push(this.$t('m.nicknameInvalid'))
      !this.$v.nickname.isUnique && errors.push(this.$t('m.nicknameBeUsed'))
      return errors
    },

    companyErrors () {
      const errors = []
      if (!this.$v.company.$dirty) return errors
      !this.$v.company.required && errors.push(this.$t('m.required'))
      !this.$v.company.minLength && errors.push(this.$t('m.companyInvalid'))
      !this.$v.company.maxLength && errors.push(this.$t('m.companyInvalid'))
      return errors
    }
  },
  watch: {
    visible: function (val) {
      this.dialog = val
    }
  },
  methods: {
    handleCancel () {
      this.dialog = false
      this.clear()
      this.$emit('cancel')
    },

    onSubmit () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.loading = true
      var postJson = {
        Email: this.email,
        OperPassword: this.password,
        OperName: this.nickname,
        CorporationName: this.company
      }

      // OPRegisterForPortdistance
      httpClient.post('/auth/OPNewRegister', postJson)
        .then((res) => {
          this.loading = false
          if (!res.data.error) {
            this.clear()
            this.$emit('save', postJson.Email)
          }
          this.loading = false
        }).catch((err) => {
          this.loading = false
        })
    }, // end onSubmit

    clear () {
      this.$v.$reset()
      this.password = ''
      this.passwordShow = false
      this.email = ''
      this.nickname = ''
      this.company = ''
    }

  }

}
</script>
